import {
  headsUpResultsPositionOptions,
  resultsPositionOptions,
} from '../Postflop/resultsPositionOptions';
import isResultsStatPositionAvailable from './availability';

// Use the same PFR/hero category as the existing group-results ring.
export const getSummaryPositions = (payload) => {
  const table = payload.game.endsWith('HU') ? 'HU' : '6max';
  const categories = table === 'HU' ? headsUpResultsPositionOptions : resultsPositionOptions;
  const groups = Object.values(categories[payload.position_type] || {})
    .flatMap((players) => Object.values(players));
  const group = groups.find((options) => options.some(
    (option) => option.value === payload.position,
  ));
  return [...new Set((group || [{ value: payload.position }])
    .filter((option) => isResultsStatPositionAvailable(
      payload.isPlo5, table, payload.bb, payload.position_type, option.value,
      payload.board_type, payload.hand_combo_type,
    ))
    .map((option) => option.value))];
};

export const calculateResultsSummary = (results) => {
  const completed = results.map(({ best }) => (Array.isArray(best) ? best : [])
    .filter((item) => item.counter >= 100 && Number.isFinite(item.percents))
    .map((item) => item.percents))
    .filter((scores) => scores.length > 0)
    .map((scores) => Math.max(...scores));

  return {
    completed_best_average: completed.length
      ? completed.reduce((sum, percent) => sum + percent, 0) / completed.length : 0,
    positions_coverage: results.length ? (completed.length * 100) / results.length : 0,
    completed_positions: completed.length,
    total_positions: results.length,
  };
};
